import { render, staticRenderFns } from "./ProfileEditTabPhoneNumbers.vue?vue&type=template&id=6d126d52&scoped=true&"
import script from "./ProfileEditTabPhoneNumbers.vue?vue&type=script&lang=js&"
export * from "./ProfileEditTabPhoneNumbers.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditTabPhoneNumbers.vue?vue&type=style&index=0&id=6d126d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d126d52",
  null
  
)

export default component.exports